/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusArchivierteAnforderungDetailDto } from '../../models/lexplus-archivierte-anforderung-detail-dto';

export interface ArchivierteAnforderungControllerGetArchivierteAnforderungDetailV1$Params {
  anforderungsversionID: number;
}

export function archivierteAnforderungControllerGetArchivierteAnforderungDetailV1(http: HttpClient, rootUrl: string, params: ArchivierteAnforderungControllerGetArchivierteAnforderungDetailV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusArchivierteAnforderungDetailDto>> {
  const rb = new RequestBuilder(rootUrl, archivierteAnforderungControllerGetArchivierteAnforderungDetailV1.PATH, 'get');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusArchivierteAnforderungDetailDto>;
    })
  );
}

archivierteAnforderungControllerGetArchivierteAnforderungDetailV1.PATH = '/v1/compliance/archiv/{anforderungsversionID}';
